import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';

import Button, {
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_WIDTHS
} from '@buyside/components/presentation/Button/button';

import { lnkdOAuth2Redirect } from '@buyside/util/urlHelper';
import { useIsMobile } from '@buyside/util/hooks/useIsMobile';

import { User } from '@interfaces/graphql-typings';

import styles from './lnkdAuthRedirectButtonStyles.scss';

const LnkdAuthRedirectButton: React.FC = () => {
  const isMobile = useIsMobile();

  const { data, loading } = useQuery<{ currentUser: Pick<User, 'id' | 'lnkdSub'> }>(gql`
    query UserOAuth {
      currentUser {
        id
        lnkdSub
      }
    }
  `);

  const lnkdSub = data?.currentUser.lnkdSub;

  if (loading || lnkdSub) return null;

  return (
    <Button
      className={styles.authButton}
      faIcon={faLinkedin}
      size={isMobile ? BUTTON_SIZES.SMALL : BUTTON_SIZES.TINY}
      text="Connect to LinkedIn"
      type={BUTTON_TYPES.PRIMARY}
      url={lnkdOAuth2Redirect()}
      width={BUTTON_WIDTHS.FULL}
    />
  );
};

export default LnkdAuthRedirectButton;
